<template>
  <div v-show="!isHidden" class="chat-widget-container" :class="{ 'is-mobile': isMobile }">
    <!-- Close button -->
    <button @click="hidePermanently" class="close-btn" title="Close chat">
      <v-icon small color="white">mdi-close</v-icon>
    </button>

    <!-- Custom Chat FAB -->
    <v-btn
      fab
      dark
      color="#114cac"
      class="chat-fab"
      @click="toggleChat"
      elevation="4"
    >
      <v-icon v-if="!isOpen">mdi-chat-processing</v-icon>
      <v-icon v-else>mdi-chevron-down</v-icon>
    </v-btn>
  </div>
</template>

<script>
export default {
  name: 'ChatWidget',
  data() {
    return {
      isHidden: false,
      isOpen: false,
      isMobile: false,
    };
  },
  mounted() {
    this.isHidden = localStorage.getItem('pacis_chat_hidden') === 'true';
    this.checkMobile();
    window.addEventListener('resize', this.checkMobile);

    // Check Tawk.to status periodically until loaded
    const checkTawk = setInterval(() => {
      if (window.Tawk_API && typeof window.Tawk_API.onChatMaximized === 'function') {
        window.Tawk_API.onChatMaximized = () => { this.isOpen = true; };
        window.Tawk_API.onChatMinimized = () => { this.isOpen = false; };

        // Aggressive hiding if the preference is set
        if (this.isHidden) {
          window.Tawk_API.hideWidget();
        }
        clearInterval(checkTawk);
      }
    }, 1000);

    // Safety check every 5 seconds to ensure Tawk.to stays hidden if preference is set
    setInterval(() => {
      if (this.isHidden && window.Tawk_API && typeof window.Tawk_API.hideWidget === 'function') {
        window.Tawk_API.hideWidget();
      }
    }, 5000);

    // Stop checking after 10 seconds
    setTimeout(() => clearInterval(checkTawk), 10000);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkMobile);
  },
  methods: {
    checkMobile() {
      this.isMobile = window.innerWidth < 640;
    },
    toggleChat() {
      if (!window.Tawk_API) {
        // eslint-disable-next-line no-console
        console.warn('Tawk.to API not loaded yet');
        return;
      }

      try {
        if (this.isOpen) {
          window.Tawk_API.minimize();
          this.isOpen = false;
        } else {
          window.Tawk_API.showWidget();
          window.Tawk_API.maximize();
          this.isOpen = true;
        }
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error('Error toggling chat:', e);
      }
    },
    hidePermanently() {
      this.isHidden = true;
      localStorage.setItem('pacis_chat_hidden', 'true');
      if (window.Tawk_API && typeof window.Tawk_API.hideWidget === 'function') {
        window.Tawk_API.hideWidget();
      }
    },
  },
};
</script>

<style scoped>
.chat-widget-container {
  position: fixed;
  bottom: 24px;
  right: 24px;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.is-mobile {
  bottom: 90px; /* Positioned higher on mobile to avoid covering action bars */
  right: 16px;
}

.chat-fab {
  width: 48px !important;
  height: 48px !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.chat-fab:hover {
  transform: translateY(-4px) scale(1.05);
  box-shadow: 0 6px 12px rgba(17, 76, 172, 0.3) !important;
}

.close-btn {
  background: rgba(17, 76, 172, 0.8);
  border-radius: 50%;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  cursor: pointer;
  margin-bottom: 8px;
  margin-right: -4px;
  opacity: 0.6; /* More visible on desktop */
  transition: opacity 0.3s, transform 0.2s;
  box-shadow: 0 4px 8px rgba(0,0,0,0.25);
  z-index: 1010;
}

.close-btn:hover {
  opacity: 1 !important;
  transform: scale(1.1);
  background: rgba(17, 76, 172, 1);
}

.chat-widget-container:hover .close-btn {
  opacity: 1;
}

@media (max-width: 640px) {
  .close-btn {
    opacity: 0.9; /* Always clearly visible on mobile touch devices */
    width: 26px;
    height: 26px;
  }
  .chat-fab {
    width: 46px !important;
    height: 46px !important;
  }
}
</style>
